import React, { useEffect } from "react";
import { Box } from "@mui/material";
import PageContent from "./partials/PageContent";
import PageHeader from "./partials/PageHeader";
import AOS from "aos";

const PageAssistSolution = ({ pageAssistData }) => {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100 });
  }, []);
  
  const { 
    title = "End to end Asistencia al viajero", 
    description = "Descripción no disponible", 
    content = "Contenido no disponible", 
    image = null 
  } = pageAssistData?.page_assist || {};

  return (
    <Box className="solution-page">
      <PageHeader
        title={title}
        prev="End to End Hoteles"
        hrefPrev="/solutions/hotels"
        next="End to End Trenes"
        hrefNext="/solutions/trains"
      />
      <PageContent
        content={content}
        title={title}
        description={description}
        image={image}
      />
    </Box>
  );
};

export default PageAssistSolution;
